export default "/images/b312dcb78d214d6efd82eccd82c707eb.avif";